import React from 'react';

import Page from 'components/Page';
import EmbedFrame from 'components/EmbedFrame';


const EmbedTemplate = ({ page: { title: { rendered: pageTitle }, acf: { embed_url } } }) => {
    return (
        <Page>
            <EmbedFrame src={embed_url} title={pageTitle + ' Embed'} />
        </Page>
    );
};


export default EmbedTemplate;
